import $ from 'jquery';

(function (root, $, undefined) {

  "use strict";

  $(function () {

    var sliders = [];

    $.fn.isInViewport = function (offset) {
      if(!offset) {
        offset = 0;
      }
      var elementTop = $(this).offset().top + offset;
      var elementBottom = elementTop + $(this).outerHeight();
      var viewportTop = $(window).scrollTop();
      var viewportBottom = viewportTop + $(window).height();
      return elementBottom > viewportTop && elementTop < viewportBottom;
    };
    
    $(function() { 
      is_mobile();

      // thisLazyLoad();
      document.addEventListener("scroll", thisLazyLoad);
      window.addEventListener("resize", thisLazyLoad);
      window.addEventListener("orientationchange", thisLazyLoad);

      document.addEventListener("wpcf7submit", function(){
        setTimeout(() => {
          reVerifyCheckbox();
        }, 500);
      });

      document.addEventListener("wpcf7mailsent", function(){
        const url = new URL(location.href);
        url.searchParams.delete('form');
        history.replaceState(null, '', url);
      });

      document.addEventListener("wpcf7mailsent", function(event){
        const form = event.target;
        
        const observer = new MutationObserver(function (mutations) {
          mutations.forEach(function (mutation) {
            if (
              mutation.type === 'attributes' &&
              mutation.attributeName === 'data-status'
            ) {
              const status = form.getAttribute('data-status');
    
              if (status === 'sent') {
                setTimeout(() => {
                  $('body').removeClass('vigilanza_open');
                }, 1000);
    
                // Una volta rilevato, puoi anche disattivare l’observer se non serve più
                observer.disconnect();
              }
            }
          });
        });

        // Osserva tutto il form in cerca di nuovi elementi inseriti
        observer.observe(form, {
          attributes: true,
          attributeFilter: ['data-status']
        });
      }, false);

      var ua = navigator.userAgent.toLowerCase();
      var isAndroid = ua.indexOf("android") > -1; //&& ua.indexOf("mobile");
      if(isAndroid) {
        document.body.className += ' is_android'; 
      }

      setCommon();
      setCommonWoocommerce();
      menu_listener();
      detect_touch();
      // checkFormFiels();

      checkScrollClass();
      
      initSwiper();
      initFancybox();

    });

    // $(window).on('load', function(){
    //   manageAccordion();
    // });
      
    $(window).on('resize', function(){
      if (this.resizeTO) clearTimeout(this.resizeTO);
      this.resizeTO = setTimeout(function () {
          $(this).trigger('resizeEnd');
      }, 300);
    });

    $(window).on('resizeEnd', function() {
      // manageAccordion();
      checkScrollClass();
      thisLazyLoad();
    });


    $(document).ajaxComplete(function(){
      reVerifyCheckbox();
      thisLazyLoad();
    });

    // function manageAccordion() {
    //   $('.single_modello').each(function(){
    //     var submenu = $(this);
    //     var vw = $(window).width();
    //     submenu.css('max-height',submenu[0].scrollHeight + 40 + (vw / 100 * 4));
    //   });

    //   $('.accordion_content').each(function(){
    //     var submenu = $(this);        
    //     // console.log(submenu[0].scrollHeight);
    //     submenu.css('max-height',submenu[0].scrollHeight + 60);
    //   });
    // } 

    function setCommon() {

      $('a[data-rel^=goto]').on('click',function(){
        var this_link = $(this);
        var attrs = this_link.data('goto');
        if(attrs != null && attrs != "") {
          var res = attrs.split(',');
          var offset = typeof res[1] !== "undefined" ? parseInt(res[1]) : null;
          var velocity = typeof res[2] !== "undefined" ? parseInt(res[2]) : 2000;
          thisGoTo(res[0], offset, velocity, res[3]);
        }
      });

      $('body').on('click','.scrollDown',function(e){
        if($('.section_1').length > 0){
          thisGoTo('.section_1',-80);
        }
      });

      $('.woocommerce-form__label-for-checkbox').addClass('checkbox');

      $('body').on('click','label.checkbox',function(){
        if($(this).closest('.woocommerce-checkout').length > 0 || $(this).closest('.woocommerce-form-login').length > 0) {
          label_checkbox_toggle($(this));
        } else {
          label_checkbox_toggle($(this).find('.wpcf7-list-item'));
        }
      });

      // fix lazy-loading images in a lower point while rendering swipers
      setTimeout(function(){
        thisLazyLoad();
      }, 200);


      if ($('.videotag').length > 0) {
        handleLazyVideo();
      }
    }

    function linkVideoSource(video) {
      if(video.hasClass('lazy')) {
        var source = video.find('source');
        var src = source.data('src');
        source.attr('src',src);
        video[0].load();
        video.removeClass('lazy');
      }
    }

    function handleLazyVideo() {
      // Add code specific to #banner_home_video
      let videoTags = $('.videotag.lazy');

      // Play video on scroll into view
      $(window).on('scroll mousemove', function() {
        videoTags.each(function() {
          let vid = $(this);
          if (vid.isInViewport() || vid.hasClass('nopause')) {
            linkVideoSource(vid);
            playpause(vid);
          } else if(!vid.hasClass('nopause')) {
            playpause(vid);
          }
        });
      });

      // Ensure the video is controlled correctly on resize
      $(window).on('resize', function() {
        videoTags.each(function() {
          let vid = $(this);
          if (vid.isInViewport() || vid.hasClass('nopause')) {
            linkVideoSource(vid);
            playpause(vid);
          } else if(!vid.hasClass('nopause')) {
            playpause(vid);
          }
        });
      });

    }

    function playpause(video){
      if(video[0].readyState === 4){
        if ((video[0].getBoundingClientRect().top + spaceBottom) <= window.innerHeight && video[0].getBoundingClientRect().bottom >= spaceTop  && getComputedStyle(video[0]).display !== "none") {
            // if(!video.isInViewport(0)){
            if(video[0].paused){
                video[0].play();
                console.log('play');
            }
        } else {
            if(!video[0].paused){
                video[0].pause();
                console.log('pause');
            }
        }   
      }
    }

    function reVerifyCheckbox() {
      $('input[type=checkbox]').each(function(){
        var el = $(this).closest('.checkbox');

        if(el.closest('.woocommerce-checkout').length > 0 || el.closest('.woocommerce-form-login').length > 0) {
          label_checkbox_toggle(el);
        } else {
          label_checkbox_toggle(el.find('.wpcf7-list-item'));
        }
      });
    }

    function label_checkbox_toggle($label) {
      var $parent = $label;
      var $el = $label.find('input[type="checkbox"]');
      if($el.is(':checked')){
          $parent.addClass('checked');
      } else {
          $parent.removeClass('checked');
      }
    }

    function checkScrollClass() {
      $(window).on('load scroll', function(){ scrolledClass() });
    } 

    var last_wh;
    const scrolledClass = function () {
      
      if($('.initial_banner').length > 0) {
        var wh = $('.initial_banner')[0].scrollHeight - 100; 
      } else {
        var wh = 50;
      }
  
      if ($(window).scrollTop() >= (wh)) {
        if (!$('body').hasClass('scrolled'))
          $('body').addClass('scrolled');
      } else {
        if ($('body').hasClass('scrolled'))
          $('body').removeClass('scrolled');
      }
    }


    const setCommonWoocommerce = () => {

      $('body').on('click','#cart_icon',function(){
        $('body').toggleClass('cart_popup_open');
      });
      $('body').on('click','#closeCartPopup',function(){
        $('body').removeClass('cart_popup_open');
      });

      $('.woocommerce-page').on( 'click', 'button.plus, button.minus', function() {
    
          // Get current quantity values
          var qty = $( this ).closest( '.quantity' ).find( '.qty' );
          var val   = parseFloat(qty.val());
          var max = parseFloat(qty.attr( 'max' ));
          var min = parseFloat(qty.attr( 'min' ));
          var step = parseFloat(qty.attr( 'step' ));

          // Change the value if plus or minus
          if ( $( this ).is( '.plus' ) ) {
            if ( max && ( max <= val ) ) {
                qty.val( max );
            } else {
                qty.val( val + step );
            }
          } else {
            if ( min && ( min >= val ) ) {
                qty.val( min );
            } else if ( val > 1 ) {
                qty.val( val - step );
            }
          }
          qty.trigger('change');
            
      });
      
      $(".woocommerce-page").on('change', 'form.woocommerce-cart-form input.qty', function(){
        var el = $('form.woocommerce-cart-form').find('button[name=update_cart]');
        if(el[0].hasAttribute('disabled')){
          el.removeAttr('disabled');
        }
      }); 
    }
      

    const initSwiper = () => {
      if ($(".swiper").length > 0) {
        // import("swiper/css");
        // import("swiper/css/effect-fade");
        // import("swiper/css/navigation");
        // import("swiper/css/pagination");
        // import("../scss/partials/swiper.scss");
        import("swiper")
          .then((module) => {
            module.Swiper.use([
              module.Autoplay,
              module.Navigation,
              // module.EffectFade,
              module.Pagination,
              module.Lazy
            ]);
  
            $(".swiper").each((index, item) => {
              const data = $(item).data("slideshow");
              
              if(data) {

                if (data.pagination && !data.pagination.type) {
                  data.pagination.renderBullet = (index, className) => {
                    return '<span class="' + className + '"></span>';
                  };
                }

                if (data.pagination && data.pagination.type == 'bullets' && data.pagination.bulletType == 'buttons') {
                  $(item).closest('section').find(".swiper-pagination").addClass('pagination-bulletButtons');
                  data.pagination.renderBullet = (index, className) => {
                    let slide_item = $(item).find('.swiper-slide').eq(index);
                    let labelButton = slide_item.data('button');
                    let colorButton = slide_item.data('buttoncolor');
                    if(labelButton) {
                      return '<div class="swiper-pagination-bullet"><a href="#" class="button_underline '+ colorButton +'">'+ labelButton +'</a></div>';
                    }
                    return '';
                  };
                }

                if (data.pagination && data.pagination.type == 'fraction') {
                  data.pagination.renderFraction = (currentClass, totalClass) => {
                    return '<span class="' + currentClass + '"></span><span class="' + totalClass + '"></span>';
                  };
                  data.pagination.formatFractionCurrent = (currentNumber) => {
                    return ('0' + currentNumber).slice(-2);
                  }
                  data.pagination.formatFractionTotal = (totalNumber) => {
                    return ('0' + totalNumber).slice(-2);
                  }
                }

              }          
      
              if (data && !data.disabled) {
                const slider = new module.Swiper(item, {
                  ...data
                });
                sliders.push(slider);

                if (data.on && data.on.playPause){
                  // Play/Pause control button
                  const controlBtn = item.closest('section')?.querySelector('.dsb-button-control');
                  
                  if(controlBtn) {
                    controlBtn.addEventListener('click', function () {
                      // console.log(this.getAttribute('aria-pressed'));
                        if (this.getAttribute('aria-pressed') === 'false') {
                          slider.autoplay.stop();
                            this.querySelector('.screen-reader-text').textContent = 'Play';
                            this.querySelector('.dashicons').classList.remove('dashicons-controls-pause');
                            this.querySelector('.dashicons').classList.add('dashicons-controls-play');
                            this.setAttribute('aria-pressed', 'true');
                        } else {
                          slider.autoplay.start();
                            this.querySelector('.screen-reader-text').textContent = 'Pause';
                            this.querySelector('.dashicons').classList.remove('dashicons-controls-play');
                            this.querySelector('.dashicons').classList.add('dashicons-controls-pause');
                            this.setAttribute('aria-pressed', 'false');
                        }
                    });
                  }
                }
              } else {
                $(item).closest('section').find(".swiper-button-next").hide();
                $(item).closest('section').find(".swiper-button-prev").hide();
                $(item).closest('section').find(".swiper-pagination").hide();
                $(item).closest('section').find(".dsb-button-control").hide();
              }
            });
          })
          .catch((e) => {
            console.log("Error loading swiper: ", e);
          });
      }
    };

    
    const initFancybox = () => {
      if ($("[data-fancybox]").length > 0) {
        import("@fancyapps/ui/dist/fancybox/fancybox.css").then(() => {
            const fancyapps = require('@fancyapps/ui/dist/fancybox/fancybox.umd.js');
            if(fancyapps.Fancybox){
              const Fancybox = fancyapps.Fancybox;
              Fancybox.bind("[data-fancybox]", {
                // Your custom options
              });
            }
          }
        );
      };
    };


    function menu_listener(){

      $('a[href="#"]').on('click',function(e){
          e.preventDefault();
      });

      $('a[href*="#form"]').on('click',function(e){
          e.preventDefault();
          thisGoTo('.footer_form',-50);
      });

      $('a[href*="#newsletter"]').on('click',function(e){
          e.preventDefault();
          $('body').addClass('form_open');
      });

      $('a[href*="#vaschetta"]').on('click',function(e){
          e.preventDefault();
          $('body').addClass('vaschetta_open');
      });

      $('body').on('click',function(e){
        if($(e.target).is('body') && $(e.target).hasClass('menu_open')){
          $('body').removeClass('menu_open');
        }
        if($(e.target).is('body') && $(e.target).hasClass('form_open')){
          $('body').removeClass('form_open');
        }
        if($(e.target).is('body') && $(e.target).hasClass('produttore_popup_open')){
          $('body').removeClass('produttore_popup_open');
          $('#popup-produttore').attr('aria-hidden', 'true');
        }
        if($(e.target).is('body') && $(e.target).hasClass('search_open')){
          $('body').removeClass('search_open');
        }
      });
      
      $('body').on('click','.search_opener', function(){
        $('body').toggleClass('search_open');
        if($("body").hasClass("search_open")) {
          $(".search-input").trigger("focus")
        }
      });

      $('body').on('click','.close_menu', function(){
        $('body').removeClass('menu_open');
      });
      $('body').on('click','.close-dialog', function(){
        const bodyclass = $(this).data('bodyclass');
        $('body').removeClass(bodyclass);
        $(window).trigger('dialogClosed');
      });

      $('body').on('click','.scrolldown', function(){
        var next = $(this).closest('section').next();
        // console.log(next);
        thisGoTo(next, -40);
      });

      $('#nav-button').on('click', function(){
        if(!$('body').hasClass('menu_open')) {
            $('body').addClass('menu_open');
        } else {
            $('body').removeClass('menu_open');
        }
      });

    }

    function thisLazyLoad() {
      if(typeof lazyLoad === "function"){
        lazyLoad();
      }
    }

    function thisGoTo(target, offset, velocity, ease) {
      if(typeof goTo === "function"){
        goTo(target, offset, velocity, ease);
      }
    }

    // function checkFormFiels() {

    //   var label, container;
    //   $('.wpcf7-form p').each(function(index,item){
    //       label = $(item).find('span.spanlabel'); //.detach(); 
    //       container = $(item).find('.wpcf7-form-control-wrap');
    //       label.appendTo(container);
    //   });

    //   var $wpcf_fields = $('.wpcf7-form-control-wrap input[type!="checkbox"], .wpcf7-form-control-wrap textarea');
    //   $wpcf_fields.each(function(){
    //       var $el = $(this);
          
    //       $el.on('load change click focusout paste autocomplete', function(){
    //           //console.log($(this).val());
    //           if($el.val() != ""){
    //               $el.closest('.wpcf7-form-control-wrap').find('input').addClass('filled');
    //               $el.closest('.wpcf7-form-control-wrap').find('textarea').addClass('filled');
    //           } else {
    //               $el.closest('.wpcf7-form-control-wrap').find('input').removeClass('filled');
    //               $el.closest('.wpcf7-form-control-wrap').find('textarea').removeClass('filled');
    //           }
    //       });
    //   });

    // }

  });


  var isMobile = false;
  function is_mobile(){
      if((/android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(navigator.userAgent.toLowerCase()))){
          isMobile = true;
      } else {
          isMobile = false;
      }
  }

  function detect_touch(){
    if("ontouchstart" in window){
      document.documentElement.className = document.documentElement.className + " touch";
    } else {
      document.documentElement.className = document.documentElement.className + " no_touch";
    }
  }

}(this, $));
